import React from 'react';
import moment from 'moment';
import {
  Container,
  Header,
  Segment,
  Icon,
  Image,
  Grid,
  Step,
  Button,
  Card,
  Label,
  Table,
  Dimmer
} from 'semantic-ui-react';
import DivWrapper from './DivWrapper';

import {FormattedMessage} from 'react-intl';
import appPreview from '../img/app_preview.png';
import Counter from './Counter';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';

import { BACKGROUND_DARK, BACKGROUND_DARK2, PRIMARY_COLOR } from '../constants';

const PageHeader = ({mobile}) => (
    <Segment 
        inverted
        textAlign='center'
        style={{ padding: '0em 0em' }}
        vertical
      >
      <Container text style={{padding: '5em 0em'}}>
        <Header
            as='h1'
            inverted
            style={{
            fontSize: mobile ? '2em' : '4em',
            fontWeight: 'normal',
            marginBottom: 0,
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.funding"/>
        </Header>
        <Header
            as='h2'
            inverted
            style={{
            fontSize: mobile ? '1.5em' : '1.7em',
            fontWeight: 'normal',
            }}
        >
            <FormattedMessage id="audory.responsiveContainer.body.funding.headText"/>
        </Header>
        
        </Container>
    </Segment>
)

let releaseDate = moment('2020-12-10 09:00:00');
let currentDate = moment();

const diff = releaseDate.diff(currentDate);
const diffDuration = moment.duration(diff);

const handleMailTo = () => {
    const email = 'max.rose@audory.io';
    let subject = `Crowdfunding Unterstützung`;
    let body = `Hey Max,

ich möchte gerne unverbindlich von euch informiert werden, sobald eure Crowdfunding Kampagne online ist.

Mit freundlichen Grüßen
VORNAME NACHNAME
`;
    subject = encodeURIComponent(subject);
    body = encodeURIComponent(body);
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  }

class CrowdfundingPage extends React.Component{

    constructor(props){
        super(props);
        this.state = {
        };
    }

    render(){
        return (
            <DivWrapper>
                <PageHeader />
              <Segment style={{ padding: '3em 0em', margin: 0 }}>
                  
                  <Container text>
          
                  
          
                    <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '0em' }}>
                        <FormattedMessage id="audory.temp.22"/>
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '1em' }}>
                        <FormattedMessage id="audory.temp.23"/>
                        
                    </p>

                    <center><Image src={appPreview} size='huge' /></center>

                    <Header as='h3' style={{ fontSize: '2em', textAlign: 'justify', marginTop: '2em' }}>
                        <FormattedMessage id="audory.temp.24"/>
                    </Header>
                    <p style={{ fontSize: '1.33em', textAlign: 'justify', marginBottom: '3em' }}>
                        <FormattedMessage id="audory.temp.25"/> <a style={{color: PRIMARY_COLOR, cursor: 'pointer'}} onClick={() => handleMailTo()}>max.rose@audory.io</a> <FormattedMessage id="audory.temp.26"/>
                    </p>
                    <center>
                        <Button color='green' size='massive' icon labelPosition='right' onClick={() => handleMailTo()}>
                            <FormattedMessage id="audory.temp.28"/>
                            <Icon name='bullhorn' />
                        </Button>
                    </center>
                  </Container>
              </Segment>
            </DivWrapper>
          );
    }
} 



export default CrowdfundingPage;


// WEBPACK FOOTER //
// ./src/components/CrowdfundingPage.js